/* DSL Smart product-pairing — suggest pairings via Shopify recommendations + product-type heuristic */
(function(){
  var slot = document.querySelector("[data-pairing]");
  if (!slot) return;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  fetch("/products/" + m[1] + ".js").then(function(r){return r.json();}).then(function(p){
    fetch("/recommendations/products?product_id=" + p.id + "&limit=6&intent=complementary").then(function(r){return r.text();}).then(function(html){
      slot.innerHTML = "<h3>Pair perfect met</h3>" + html;
      if (window.DSL_AB) window.DSL_AB.track("pairing_loaded", {pid: p.id});
    });
  });
})();